module.exports = __webpack_public_path__ + "static/media/anc2ru.a13a20a8.pdf";